import type { NodeViewerComponent } from '.'
import { OrderedList } from '../../components'

export const OrderedListNodeViewer: NodeViewerComponent = ({ children }) => (
  <OrderedList>{children}</OrderedList>
)
